import React from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import CodeBlock from './CodeBlock';

const Root = styled.div`
  max-width: 700px;
  margin: auto;
`;

const Category = styled.h6`
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 14px;
  font-weight: 500;
  margin-top: 50px;
  text-align: center;
  text-transform: capitalize;
`;
const Title = styled.h1`
  color: ${(props) => props.theme.palette.text.primary};
  font-size: 48px;
  letter-spacing: -0.73px;
  margin: 8px 0 40px;
  text-align: center;
`;
const Date = styled.p`
  color: #bcc4da;
  font-size: 16px;
  margin-left: 26px;
`;
const HeroImg = styled.img`
  display: flex;
  width: 100%;
  margin-bottom: 40px;
  border-radius: 24px;
  ransform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg)
    skew(0deg, 0deg);
  opacity: 1;
  transform-style: preserve-3d;
`;
const MiniHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;

const AuthorCardWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const AuthorImage = styled.img`
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: block;
`;
const AuthorName = styled.p`
  color: ${(props) => props.theme.palette.text.secondary};
  margin-left: 16px;
`;
function AuthorCard({ avatar, author }) {
  return (
    <AuthorCardWrapper>
      <AuthorImage src={avatar} alt="" />
      <AuthorName>{author || 'unknow'}</AuthorName>
    </AuthorCardWrapper>
  );
}

const renderers = {
  code: CodeBlock,
};

const StyledMD = styled(ReactMarkdown)`
  padding: 30px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.theme.palette.text.primary};
    margin: 20px 0;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }
  & p {
    font-size: 1rem;
    line-height: 1.75;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
    padding-bottom: 2px;
    color: ${(props) => props.theme.palette.text.secondary};
  }
  & ul {
    margin-top: 10px;
    font-size: 1rem;
    font-size: 1rem;

    li {
      color: ${(props) => props.theme.palette.text.secondary};
      list-style: unset;
      padding-bottom: 2px;
    }
  }
  & img {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  pre {
    overflow-x: auto;
    font-size: 0.9em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding: 0.8571429em 1.1428571em;
    font-family: inherit;
  }
  a {
    color: ${(props) => props.theme.palette.text.link};
    text-decoration: underline;
    font-weight: 500;
  }
  code {
    border-radius: 0.375rem;
    border-width: 1px;
    padding: 0.125rem 0.25rem;
    font-weight: 500;
    font-family: inherit;
    font-size: 0.9em;
  }
`;

const BlogPostTemplate = ({ category, title, avatar, author, date, heroImg, content }) => {
  return (
    <Root>
      <Category>{category}</Category>
      <Title>{title}</Title>
      <MiniHeader>
        <AuthorCard avatar={avatar} author={author} />
        <Date>{date}</Date>
      </MiniHeader>
      <HeroImg src={heroImg} alt="" />
      <StyledMD renderers={renderers}>{content}</StyledMD>
    </Root>
  );
};

export { BlogPostTemplate };
